import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'base-ui'

import { MarketplacePartnerRegisterPageFormBasicInformationCompanyType } from './MarketplacePartnerRegisterPageFormBasicInformationCompanyType'
import { MarketplacePartnerRegisterPageFormBasicInformationsCompanyInformations } from './MarketplacePartnerRegisterPageFormBasicInformationsCompanyInformations'
import { MarketplacePartnerRegisterPageFormBasicInformationsContactDetails } from './MarketplacePartnerRegisterPageFormBasicInformationsContactDetails'
import { MarketplacePartnerRegisterPageFormBasicInformationsMarkets } from './MarketplacePartnerRegisterPageFormBasicInformationsMarkets'
import { MarketplacePartnerRegisterPageFormBasicInformationsRespectiveLanguage } from './MarketplacePartnerRegisterPageFormBasicInformationsRespectiveLanguage'

export const MarketplacePartnerRegisterPageFormBasicInformations: FC = () => {
  return (
    <div className="flex flex-col gap-10">
      <Heading level={2} size="l">
        <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.title" />
      </Heading>
      <div className="text-m">
        <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.description" />
      </div>
      <MarketplacePartnerRegisterPageFormBasicInformationsContactDetails />
      <MarketplacePartnerRegisterPageFormBasicInformationsCompanyInformations />
      <MarketplacePartnerRegisterPageFormBasicInformationCompanyType />
      <MarketplacePartnerRegisterPageFormBasicInformationsMarkets />
      <MarketplacePartnerRegisterPageFormBasicInformationsRespectiveLanguage />
    </div>
  )
}
